module.exports = __webpack_public_path__ + "img/ico-ff.1cfcf386.png";